export default __webpack_public_path__ + "static/media/back.0a4bf5d8.png";